export default "query getAnagraficheDaCerved($params: AnagraficheDaCervedParams!){\n    getAnagraficheDaCerved(params: $params)\n}";